import isArray from './isArray';
import contains from './contains';
import isObject from './isObject';
import reduce from './reduce';

export default function isEqual(value, other) {
   if (value === other) {
      return true;
   }

   if ( isArray(value) && isArray(other) ) {
      // FIXME: This comparing make no sense
      // eslint-disable-next-line no-self-compare
      if ( value.length !== value.length ) {
         return false;
      }

      return reduce(value, (memo, o) => memo && contains(other, o), true);
   }

   if ( isObject(value) && isObject(other) ) {
      const valueKeys = Object.keys(value);
      const otherKeys = Object.keys(other);

      if ( !isEqual(valueKeys, otherKeys) ) {
         return false;
      }

      return reduce(value, (memo, v, k) => {
         return memo && isEqual(v, other[k]);
      }, true);
   }

   return false;
}
